import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom';
import DashboardModule from './Dashboard/DashboardModule';
import TopBar from './topbar/TopBar';
import SideBar from './Sidebar/SideBar';
import { SidebarContext } from './Sidebar/SidebarContext';

function VendorDashboard() {
    const { isSidebarCollapsed, toggleSidebar } = useContext(SidebarContext);
    return (
      // <SidebarProvider>
      <div>
        <div className="bg-color h-screen overflow-scroll sm:overflow-x-auto">
          <div className="flex overflow-x-scroll">
            <div
              className={`${
                isSidebarCollapsed ? "md:w-[7%]" : "md:w-[20%]"
              } h-screen sm:w-0`}
            >
              <SideBar />
            </div>
           
            <div
              className={`${
                !isSidebarCollapsed ? "md:w-[83%]" : "md:w-[93%]"
              } sm:w-[100%] w-full bg-[#F6F6F6]`}
            >
              {/* <div className="md:w-[85%] sm:w-[100%] w-full bg-[#F6F6F6]"> */}
              <div
                className={` ${
                  !isSidebarCollapsed ? "md:w-[84.2%] " : "md:w-[92.2%] "
                } sm:w-[100%] w-full`}
              >
                <TopBar />
              </div>
              <section className="sm:content pb-3.5 w-full pl-10 pt-[75px] sm:mb-10 sm:mt-0 mb-12 mx-auto">
                <Routes>
                  <Route path="activateDashbord/*" element={<DashboardModule />} />
                  
                  {/* Add other routes here */}
                </Routes>
              </section>
            </div>
          </div>
        </div>
      </div>
      // </SidebarProvider>
    );
  }
  

export default VendorDashboard
